import { H3 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { useAppSelector } from '@/redux/hooks';
import {
    getCatalogLotsListed,
    getTimedPlusCatalogClosedLotCount,
} from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

type Props = {
    catalogId: number;
    className?: string;
};

export const CatalogStatusBar = ({ catalogId, className }: Props) => {
    const total = useAppSelector((state) => getCatalogLotsListed(state, catalogId)) || 100;
    const closedLotsCount = useAppSelector((state) => getTimedPlusCatalogClosedLotCount(state, catalogId));
    const percentage = total ? Math.round((closedLotsCount / total) * 100) : 0;
    const formatMessage = useAppFormatMessage();

    return (
        <div
            className={cn('block w-full text-center', className)}
            data-testid="catalog-status-bar"
        >
            <H3 className="my-sm">
                {formatMessage(['catalogPage', 'catalogStatus', 'progressStatus'], {
                    values: { current: closedLotsCount, total },
                })}
            </H3>
            <div className="mb-lg h-2 w-full flex-1 overflow-hidden rounded-md border border-border-secondary bg-background-primary">
                <div
                    className="h-full rounded-md bg-info-500 transition-all duration-[250ms]"
                    data-testid="catalog-status-bar-progress"
                    style={{ width: `${Math.max(percentage, 2.5)}%` }}
                />
            </div>
        </div>
    );
};
